export const selectCompany = `select_company`
export const fromDate = `from_date_id`
export const toDate = `to_date_id`
export const reportView = 'report_view'
export const reportType = 'report_type'
export const stateId = `state_id`
export const gstIn = 'select_GSTIN'
export const selectBranches = 'select_branches'
export const includeBranches = 'includeBranches'
export const reportmainButton = `report_go_button`

export const srcCity = 'source_city'
export const srcBranch = 'source_branch'
export const destCity = `destination_city`
export const destBranch = 'destination_branch'
export const payType = 'payment_type'
export const gstPaidBy = 'gst_paid_by'
export const bookingType = 'booking_type'
export const summaryView = 'summary_view'
//creditLimit
export const creditTransFromDate = `credit_trans_From_date_id`
export const creditTransSplitButton = `credit_Trans_SplitButton`
export const creditSummaryFromDate = `credit_summary_From_date_id`
export const creditSummarySplitButton = `credit_summary_SplitButton`
export const creditUsageFromDate = `credit_Usage_From_date_id`
export const creditUsageSplitButton = `credit_Usage_SplitButton`
//gst report
export const gstSplitButton = `GST_SplitButton`
export const gstFromDate = `GST_From_date_id`

export const selectVehicle='Select_Vehicle'

export const generateMemo='Generate_Memo'
export const inclGSTComm='Incl_GST_Comm'
export const offlineBooking='Offline_Booking'
export const toPayHamali='To_Pay_Hamali'